import { put, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  setLoading,
  loadTrackingStatusSuccess,
  loadTrackingStatusFailed,
  setPostCodeCheckLoading,
  checkPostCodeSuccess,
  checkPostCodeRejected
} from '../Slices';
import { StatusApiService } from '../../Services';
import { PostCodeCheckResponse, TrackingStatusResponse } from '../../Models';
const statusAPiService = new StatusApiService();

// worker Saga: will be fired on USER_FETCH_REQUESTED actions
function* fetchStatus({ payload }: PayloadAction<string>) {
  try {
    yield put(setLoading(true));
    const TrackingResponse: TrackingStatusResponse = yield statusAPiService.getTrackingStatus(
      payload
    );

    yield put(
      loadTrackingStatusSuccess({
        ...TrackingResponse,
        statuses: TrackingResponse.statuses?.map((s) => ({ ...s, shipmentNumber: payload }))
      })
    );
    yield put(setLoading(false));
  } catch (e) {
    yield put(loadTrackingStatusFailed({ status: 500, message: 'Ein Fehler ist aufgetreten' })),
      yield put(setLoading(false));
  }
}

function* postCodeCheck({ payload }: PayloadAction<{ postCode: string; shipmentNumber: string }>) {
  try {
    yield put(setPostCodeCheckLoading(true));
    const postCodeCheckResponse: PostCodeCheckResponse = yield statusAPiService.postCodeCheck(
      payload.postCode,
      payload.shipmentNumber
    );
    yield put(checkPostCodeSuccess(postCodeCheckResponse));
    yield put(setPostCodeCheckLoading(false));
  } catch (e) {
    yield put(checkPostCodeRejected({ status: 500, message: 'Ein Fehler ist aufgetreten' }));
    yield put(setPostCodeCheckLoading(false));
  }
}

export function* getShipmentStatusSaga() {
  yield takeEvery('statuses/loadTrackingStatus', fetchStatus);
  yield takeEvery('statuses/loadCheckPostCode', postCodeCheck);
}
